import * as React from 'react'
import { KvBox } from 'src/design-system/components/atoms/kvbox'
import { HeadcountOverview } from '../headcount-overview'
import styles from '../current-org-summary/CurrentImpact.module.scss'
import kvBoxStyles from 'src/design-system/components/atoms/kvbox/KvBox.module.scss'
import { useWfiContext } from '../WfiContext'
import { formatCurrency as $, noDecimals, sign } from '../utils'
import { Team } from '../types'
import { getSummaryForTeam } from '../current-org-summary/CurrentImpact'

type ProposalImpactProps = {
  id: number
  onSelect: (teamId: number) => void
  selectedTeam: number | null
  teams: Team[]
}

export const ProposalImpact: React.VFC<ProposalImpactProps> = ({
  id,
  onSelect,
  selectedTeam,
  teams,
}) => {
  const { orgSnapshot, analyses } = useWfiContext()
  const fullAnalysis = analyses.find((a) => a.id === id)

  if (fullAnalysis == null || orgSnapshot == null) return null
  const teamSummary = selectedTeam
    ? getSummaryForTeam(orgSnapshot, selectedTeam)
    : null

  const summary = teamSummary ?? orgSnapshot
  const teamAnalysis = selectedTeam
    ? getSummaryForTeam(fullAnalysis, selectedTeam)
    : null
  const analysis = teamAnalysis ?? fullAnalysis

  const orgSizeDiff = analysis.orgSize - (summary.orgSize ?? 0)
  const totalCostDiff =
    ((analysis.totalCost - (summary.totalCost ?? 0)) /
      ((analysis.totalCost + (summary.totalCost ?? 0)) / 2)) *
    100

  return (
    <div className={styles.container}>
      <div>
        <p className={styles.headcountTitle}>Team headcount overview</p>
        <HeadcountOverview onSelect={onSelect} teams={teams} />
      </div>
      <div className={styles.statsContainer}>
        <p className={styles.title}>Organizational Insights</p>
        <KvBox
          className={kvBoxStyles.bottomBorderOnly}
          Key={selectedTeam == null ? 'Organization Size' : 'Team Size'}
          value={
            <>
              {analysis.orgSize}{' '}
              {orgSizeDiff != 0 && (
                <span className={styles.diff}>
                  ({sign(orgSizeDiff)}
                  {orgSizeDiff} employees)
                </span>
              )}
            </>
          }
        />
        <KvBox
          className={kvBoxStyles.bottomBorderOnly}
          Key="Total Cost"
          value={
            <>
              {$(analysis.totalCost)}{' '}
              {totalCostDiff != 0 && (
                <span className={styles.diff}>
                  ({sign(totalCostDiff)}
                  {noDecimals(totalCostDiff)}%)
                </span>
              )}
            </>
          }
        />
        <KvBox
          className={kvBoxStyles.openBox}
          Key="Roles"
          value={analysis.numRoles}
        />
        <KvBox
          className={kvBoxStyles.openBox}
          Key="Avg Salary"
          value={$(analysis.avgSalary)}
        />
      </div>
    </div>
  )
}
